export default __webpack_public_path__ + "static/media/1617 utensils side.7f71a95c.png";